enum ProductSectionAccessPermissionsActionTypes {
  GetProductSectionAccessPermissions = 'productSectionAccessPermissions/GetProductSectionAccessPermissions',
  UpdateProductSectionAccessPermissions = 'productSectionAccessPermissions/UpdateProductSectionAccessPermissions',
  ResetProductSectionAccessPermissionsUpdatingState = 'productSectionAccessPermissions/ResetProductSectionAccessPermissionsUpdatingState',
  OpenResetToDefaultsPopUp = 'productSectionAccessPermissions/OpenResetToDefaultsPopUp',
  CloseResetToDefaultsPopUp = 'productSectionAccessPermissions/CloseResetToDefaultsPopUp',
}

export default ProductSectionAccessPermissionsActionTypes;
